export default __webpack_public_path__ + "static/media/baby_dress.152bb4b4.jpg";